<template>
    <transition name="modal">
        <div class="modal-mask">
            <div class="modal-wrapper">
                <div class="modal-container" v-on:click.stop="">
                    <h2 class="fs18 mb8">{{ params.title }}</h2>
                    <div class="modal-body radius8 pd24 mt8p mb8p">
                        <slot name="body">
                            <p class="fs14 mb16">{{ params.message }}</p>
                        </slot>
                    </div>
                    <div class="modal-footer">
                        <slot name="footer">
                            <button type="button" class="button fs16 w50p mt16 mb0 pd16 radius200" v-bind:disabled="this.button" @click="cancelApi()">{{ params.buttonMessage }}</button>
                            <button type="button" class="button fs16 w50p mt16 mb0 pd16 radius200" v-bind:disabled="this.button" @click="closeModal()">戻る</button>
                        </slot>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>
<script>
import modal from '@/assets/v3/modal'
import maintenancePackCancel from '@/store/Api/MaintenancePack/cancel'

export default {
  data () {
    return {
      button: false
    }
  },
  props: ['params'],
  methods: {
    openErrorModal (message) {
      modal.alert(message)
    },
    openCompleteModal (message) {
      modal.completeModal(message, '解約')
    },
    closeModal () {
      this.nativeEVENTSet('MpTopCancelModalButton', 'CLOSE_CANCEL_MODAL', 'TAP')
      modal.close()
    },
    async cancelApi () {
      this.nativeEVENTSet('MpTopCancelModalButton', 'CANSEL_MP', 'TAP')
      this.button = true
      await maintenancePackCancel.put(this.params.headersInfo).then(res => {
        modal.close()
        this.openCompleteModal('ご利用頂き誠にありがとうございました。「閉じる」を押下すると画面が切り替わります。')
      }).catch(e => {
        modal.close()
        console.log('maintenancePackCancel-error')
        console.log(e.message)
        this.openErrorModal('ただいまアクセスが集中している可能性がございます。恐れ入りますが、時間をおいて再度お試しください。')
      })
    }
  }
}
</script>
